import api from "../../../api/axios";

// Feature-local wrappers for Viewing endpoints used by the
// /clients/:clientId viewings section (CRM-WORKFLOW-C1).
//
// Endpoints (per backend/app/apps/clients/views.py ViewingViewSet):
//   GET  /api/crm/viewings/?client=<id>
//   POST /api/crm/viewings/
//
// Property options for the create modal reuse the existing active-
// property list endpoint:
//   GET  /api/realty/properties/?search=&ordering=-created_at&page_size=20
//
// Stateless request wrappers — no cache, no retry, no invalidation.

export const fetchClientViewings = (clientId) =>
  api
    .get(`/crm/viewings/`, { params: { client: clientId } })
    .then((res) => res.data);

export const createClientViewing = (body) =>
  api.post(`/crm/viewings/`, body).then((res) => res.data);

export const fetchViewingPropertyOptions = (params = {}) =>
  api
    .get(`/realty/properties/`, {
      params: {
        ordering: "-created_at",
        page_size: 20,
        ...params,
      },
    })
    .then((res) => res.data);
